//登出确认对话框

import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import LogoutIcon from "@mui/icons-material/Logout";

// 样式化组件
const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: 16,
    padding: 0,
    maxWidth: 400,
    width: "100%",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
  },
}));

const DialogHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "16px 24px",
  borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: "32px 24px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, 0.05)",
  borderRadius: "50%",
  padding: theme.spacing(2),
  marginBottom: theme.spacing(3),
  color: "rgba(0, 0, 0, 0.7)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: 64,
  height: 64,
}));

const ActionButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5, 4),
  borderRadius: 8,
  fontWeight: 600,
  textTransform: "none",
  fontSize: "1rem",
  boxShadow: "none",
  margin: theme.spacing(1),
}));

const ButtonsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  marginTop: theme.spacing(3),
}));

const LogoutConfirmDialog = ({ open, onClose, onConfirm, username }) => {
  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby="logout-dialog-title"
    >
      <DialogHeader>
        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 600,
            color: "rgba(0, 0, 0, 0.8)",
          }}
        >
          确认登出
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: "rgba(0, 0, 0, 0.6)",
            "&:hover": {
              color: "rgba(0, 0, 0, 0.8)",
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogHeader>

      <StyledDialogContent>
        <IconWrapper>
          <LogoutIcon fontSize="large" />
        </IconWrapper>

        <Typography
          variant="h6"
          component="h3"
          sx={{
            textAlign: "center",
            fontWeight: 600,
            color: "rgba(0, 0, 0, 0.8)",
            mb: 2,
          }}
        >
          {username ? `${username}，` : ""}您确定要登出吗？
        </Typography>

        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.6)",
            lineHeight: 1.6,
          }}
        >
          登出后，您将需要重新登录才能访问管理功能。
        </Typography>

        <ButtonsContainer>
          <ActionButton
            variant="outlined"
            onClick={onClose}
            sx={{
              color: "rgba(0, 0, 0, 0.7)",
              borderColor: "rgba(0, 0, 0, 0.2)",
              "&:hover": {
                borderColor: "rgba(0, 0, 0, 0.5)",
                backgroundColor: "rgba(0, 0, 0, 0.03)",
              },
            }}
          >
            取消
          </ActionButton>
          <ActionButton
            variant="contained"
            onClick={onConfirm}
            sx={{
              background: "rgba(0, 0, 0, 0.7)",
              "&:hover": {
                background: "rgba(0, 0, 0, 0.8)",
              },
            }}
          >
            确认登出
          </ActionButton>
        </ButtonsContainer>
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default LogoutConfirmDialog;
